module.exports = __webpack_public_path__ + "bf19a41e.png";